module.exports = __webpack_public_path__ + "img/749DCBE9905D3845.44f1eefb.png";